import React, {Component} from 'react';
import styled from 'styled-components';
import {brk} from "../styles/constants";
import ButtonUnderline from './ButtonUnderline'


const Container = styled.div`
  display: flex;
  width : 50%;
   
   @media (max-width : ${brk.S}) {
   width : 100%
  }
   
  
   
`;


const Description = styled.div`
`;
const ContentBlock = styled.div`
    padding-top : 45px; 
    padding-bottom : 40px; 
   width : 80%;
   max-width : 500px;

    margin:auto;
`;


const BackgroundImage = styled.div`
    width: 100%;
    height: 100%;
	min-height: inherit;
	position: relative;
	display: block;
	background-size: cover !important;
	background-position : center !important;
`



class BlockPress extends Component {
    render() {
        const {
            block
        } = this.props;


        let title;
        if(block.title){
            title = <h2>{ block.title }</h2>;
        }

        let author;
        if(block.author){
            author = <h3>{ block.author }</h3>;
        }

        let text;
        if(block.articleContent){
            text = <Description className={'description'} dangerouslySetInnerHTML={{ __html: block.articleContent.childMarkdownRemark.html }}/>
        }




        return (
            <Container >
                    <ContentBlock>
                    { title }
                    { text }
                    { author }
                    </ContentBlock>
            </Container>
        )
    }
}


export default BlockPress;